/**
 * INFINITY LIFE 2.0 — Task Create & Edit Modal Component
 */

import { store } from '../state.js';
import { api, showToast } from '../api.js';

export function renderTaskModal() {
  const { modals } = store.get();
  const { isOpen, mode, task } = modals.task;

  if (!isOpen) {
    return `<div id="task-modal-container"></div>`;
  }

  const isEdit = mode === 'edit' && task;
  const titleVal = isEdit ? escapeHtml(task.title) : '';
  const descVal = isEdit ? escapeHtml(task.description || '') : '';
  const prioVal = isEdit ? task.priority : 'medium';
  const dateVal = isEdit ? (task.due_date || '') : new Date().toISOString().split('T')[0];
  const timeVal = isEdit ? (task.due_time ? task.due_time.substring(0, 5) : '') : '';
  const estVal = isEdit ? task.estimated_minutes : 30;
  const locVal = isEdit ? task.context_location : 'any';
  const isWork = isEdit ? !!task.is_work : false;
  const checklists = isEdit && task.checklists ? task.checklists : [];

  return `
    <div class="modal-overlay open" id="task-modal-overlay">
      <div class="modal-card">
        <div class="modal-header">
          <h2 class="modal-title">${isEdit ? 'Editar Tarefa' : 'Nova Tarefa'}</h2>
          <button class="btn-close" id="btn-close-task-modal">✕</button>
        </div>

        <form id="task-form">
          <!-- Title -->
          <div class="form-group">
            <label class="form-label">Título da Tarefa *</label>
            <input type="text" id="task-title-input" class="form-input" required 
                   placeholder="Ex: Desenvolver proposta comercial ou Estudar PHP" value="${titleVal}" autofocus />
          </div>

          <!-- Description -->
          <div class="form-group">
            <label class="form-label">Descrição ou Notas</label>
            <textarea id="task-desc-input" class="form-textarea" rows="3" 
                      placeholder="Detalhes adicionais, links ou objetivos...">${descVal}</textarea>
          </div>

          <!-- Priority & Scope -->
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Prioridade</label>
              <select id="task-priority-input" class="form-select">
                <option value="urgent" ${prioVal === 'urgent' ? 'selected' : ''}>🔥 Urgente</option>
                <option value="high" ${prioVal === 'high' ? 'selected' : ''}>⚡ Alta</option>
                <option value="medium" ${prioVal === 'medium' ? 'selected' : ''}>🔹 Média</option>
                <option value="low" ${prioVal === 'low' ? 'selected' : ''}>🌱 Baixa</option>
              </select>
            </div>

            <div class="form-group">
              <label class="form-label">Contexto / Dispositivo</label>
              <select id="task-location-input" class="form-select">
                <option value="any" ${locVal === 'any' ? 'selected' : ''}>⚡ Qualquer lugar</option>
                <option value="online" ${locVal === 'online' ? 'selected' : ''}>🌐 Online</option>
                <option value="computer" ${locVal === 'computer' ? 'selected' : ''}>💻 No computador</option>
                <option value="mobile" ${locVal === 'mobile' ? 'selected' : ''}>📱 No celular</option>
                <option value="call" ${locVal === 'call' ? 'selected' : ''}>📞 Ligação</option>
                <option value="meeting" ${locVal === 'meeting' ? 'selected' : ''}>👥 Reunião</option>
                <option value="in_person" ${locVal === 'in_person' ? 'selected' : ''}>📍 Presencial</option>
              </select>
            </div>
          </div>

          <!-- Due Date & Due Time -->
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Data de Vencimento</label>
              <input type="date" id="task-date-input" class="form-input" value="${dateVal}" />
            </div>

            <div class="form-group">
              <label class="form-label">Horário (Opcional)</label>
              <input type="time" id="task-time-input" class="form-input" value="${timeVal}" />
            </div>
          </div>

          <!-- Estimated Minutes & Reminder -->
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Tempo Estimado</label>
              <select id="task-est-input" class="form-select">
                <option value="15" ${estVal == 15 ? 'selected' : ''}>15 minutos</option>
                <option value="30" ${estVal == 30 ? 'selected' : ''}>30 minutos</option>
                <option value="45" ${estVal == 45 ? 'selected' : ''}>45 minutos</option>
                <option value="60" ${estVal == 60 ? 'selected' : ''}>1 hora</option>
                <option value="90" ${estVal == 90 ? 'selected' : ''}>1 hora e meia</option>
                <option value="120" ${estVal == 120 ? 'selected' : ''}>2 horas</option>
                <option value="180" ${estVal == 180 ? 'selected' : ''}>3 horas</option>
                <option value="0" ${estVal == 0 ? 'selected' : ''}>Sem estimativa</option>
              </select>
            </div>

            <div class="form-group">
              <label class="form-label">Lembrete Automático</label>
              <select id="task-reminder-input" class="form-select">
                <option value="">Sem lembrete</option>
                <option value="0">No horário marcado</option>
                <option value="10" selected>10 minutos antes</option>
                <option value="30">30 minutos antes</option>
                <option value="60">1 hora antes</option>
              </select>
            </div>
          </div>

          <!-- Work vs Personal Checkbox -->
          <div class="form-group" style="display: flex; align-items: center; gap: 10px; margin-top: 6px;">
            <input type="checkbox" id="task-work-checkbox" ${isWork ? 'checked' : ''} style="width: 18px; height: 18px; cursor: pointer;" />
            <label for="task-work-checkbox" style="cursor: pointer; font-size: 0.9rem; font-weight: 600;">
              💼 Vincular ao módulo "Meu Negócio" (Trabalho autônomo / freelancer)
            </label>
          </div>

          <!-- Checklist Builder -->
          <div class="form-group" style="margin-top: 14px;">
            <label class="form-label">Checklist / Subtarefas</label>
            <div id="checklist-items-container" style="display: flex; flex-direction: column; gap: 6px; margin-bottom: 8px;">
              ${checklists.map((chk, i) => `
                <div class="checklist-row" style="display: flex; gap: 8px; align-items: center;">
                  <input type="text" class="form-input checklist-item-input" value="${escapeHtml(chk.title)}" style="padding: 6px 10px;" />
                  <button type="button" class="btn-icon btn-remove-chk" style="width: 32px; height: 32px; color: var(--rose-accent);">✕</button>
                </div>
              `).join('')}
            </div>
            <div style="display: flex; gap: 8px;">
              <input type="text" id="new-chk-input" class="form-input" placeholder="Nova etapa (Pressione Enter para adicionar)..." style="padding: 6px 12px;" />
              <button type="button" class="btn-secondary" id="btn-add-chk-item" style="padding: 6px 14px; white-space: nowrap;">＋ Adicionar</button>
            </div>
          </div>

          <!-- Submit Buttons -->
          <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px;">
            <button type="button" class="btn-secondary" id="btn-cancel-task">Cancelar</button>
            <button type="submit" class="btn-primary" id="btn-submit-task">
              <span>✓</span> <span>${isEdit ? 'Salvar Alterações' : 'Criar Tarefa'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  `;
}

function escapeHtml(str) {
  if (!str) return '';
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

export function attachTaskModalEvents(container) {
  const closeBtn = container.querySelector('#btn-close-task-modal');
  const cancelBtn = container.querySelector('#btn-cancel-task');
  const overlay = container.querySelector('#task-modal-overlay');

  const closeModal = () => store.closeTaskModal();

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (cancelBtn) cancelBtn.addEventListener('click', closeModal);
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });
  }

  // Checklist dynamic adding
  const addChkBtn = container.querySelector('#btn-add-chk-item');
  const newChkInput = container.querySelector('#new-chk-input');
  const chkContainer = container.querySelector('#checklist-items-container');

  const addChecklistItem = () => {
    const val = newChkInput.value.trim();
    if (!val) return;

    const row = document.createElement('div');
    row.className = 'checklist-row';
    row.style.cssText = 'display: flex; gap: 8px; align-items: center;';
    row.innerHTML = `
      <input type="text" class="form-input checklist-item-input" value="${escapeHtml(val)}" style="padding: 6px 10px;" />
      <button type="button" class="btn-icon btn-remove-chk" style="width: 32px; height: 32px; color: var(--rose-accent);">✕</button>
    `;

    row.querySelector('.btn-remove-chk').addEventListener('click', () => row.remove());
    chkContainer.appendChild(row);
    newChkInput.value = '';
    newChkInput.focus();
  };

  if (addChkBtn) addChkBtn.addEventListener('click', addChecklistItem);
  if (newChkInput) {
    newChkInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        addChecklistItem();
      }
    });
  }

  // Remove existing checklist rows
  container.querySelectorAll('.btn-remove-chk').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.target.closest('.checklist-row').remove();
    });
  });

  // Form submission
  const form = container.querySelector('#task-form');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const title = container.querySelector('#task-title-input').value.trim();
      const description = container.querySelector('#task-desc-input').value.trim();
      const priority = container.querySelector('#task-priority-input').value;
      const context_location = container.querySelector('#task-location-input').value;
      const due_date = container.querySelector('#task-date-input').value;
      const due_time = container.querySelector('#task-time-input').value;
      const estimated_minutes = parseInt(container.querySelector('#task-est-input').value, 10) || 0;
      const is_work = container.querySelector('#task-work-checkbox').checked ? 1 : 0;
      const reminderVal = container.querySelector('#task-reminder-input').value;
      const reminder_minutes = reminderVal !== '' ? parseInt(reminderVal, 10) : null;

      // Extract checklists
      const checklistInputs = container.querySelectorAll('.checklist-item-input');
      const checklists = [];
      checklistInputs.forEach((inp) => {
        const itemText = inp.value.trim();
        if (itemText) checklists.push({ title: itemText, is_completed: 0 });
      });

      const { modals } = store.get();
      const { mode, task } = modals.task;

      try {
        if (mode === 'edit' && task) {
          await api.updateTask(task.id, {
            title,
            description,
            priority,
            context_location,
            due_date,
            due_time: due_time || null,
            estimated_minutes,
            is_work,
            checklists,
          });
          showToast('Tarefa atualizada!', 'success');
        } else {
          await api.createTask({
            title,
            description,
            priority,
            context_location,
            due_date,
            due_time: due_time || null,
            estimated_minutes,
            is_work,
            checklists,
            reminder_minutes,
          });
          showToast('Tarefa criada com sucesso!', 'success');
        }

        store.closeTaskModal();
        window.dispatchEvent(new CustomEvent('infinity:refresh-data'));
      } catch (err) {
        showToast(err.message, 'error');
      }
    });
  }
}
